import {Directive} from '@angular/core';
@Directive({
  selector: '.dropdown-menu-content'
})
export class DropdownMenuDirective {}